export const ORDERPASS_MODAL_RADIUS = 8;
export const ORDERPASS_MODAL_PADDING = 24;
export const ORDERPASS_BUTTON_MIN_HEIGHT = 44;
export const ORDERPASS_BUTTON_HEIGHT = 48;

export const orderPassModalPaperStyle = (extra = {}) => ({
  borderRadius: ORDERPASS_MODAL_RADIUS,
  overflow: "hidden",
  ...extra,
});

export const orderPassModalTitleStyle = (language, extra = {}) => ({
  borderBottom: "1px solid #e5e5e5",
  padding: ORDERPASS_MODAL_PADDING,
  textAlign: language == "english" ? "left" : "right",
  ...extra,
});

export const orderPassModalContentStyle = (extra = {}) => ({
  padding: ORDERPASS_MODAL_PADDING,
  ...extra,
});

export const orderPassModalActionsStyle = (extra = {}) => ({
  padding: ORDERPASS_MODAL_PADDING,
  borderTop: "1px solid #e5e5e5",
  backgroundColor: "white",
  ...extra,
});

export const orderPassButtonStyle = (extra = {}) => ({
  minHeight: ORDERPASS_BUTTON_MIN_HEIGHT,
  height: ORDERPASS_BUTTON_HEIGHT,
  borderRadius: 6,
  padding: "0 16px",
  textTransform: "none",
  fontSize: 16,
  fontWeight: 700,
  lineHeight: 1.2,
  boxShadow: "none",
  ...extra,
});

export const orderPassIconButtonStyle = (extra = {}) => ({
  width: ORDERPASS_BUTTON_MIN_HEIGHT,
  height: ORDERPASS_BUTTON_MIN_HEIGHT,
  minWidth: ORDERPASS_BUTTON_MIN_HEIGHT,
  padding: 8,
  ...extra,
});
